import { urn }              from 'helpers/ModelDictionary';
import SalesPrivateApiModel from '../../abstracts/SalesPrivateApiModel';

@urn('$', 'sales', 'recurring_mode')
export default class RecurringModeModel extends SalesPrivateApiModel {

	static get path(): string {
		return '/recurring_modes/{?id}';
	}

	public _filters: ModelFiltersExtended<{
		enabled: boolean;
	}> = {};

	public get label(): string {
		return this.get('label', '');
	}

	public get reference(): string {
		return this.get('reference', '');
	}
}